import {Alert, useOpenModal} from '@/components/Modal'
import openWindow from '@/script/openWindow.mjs'

export default () => {
    const openModal = useOpenModal()

    return (map, nodes) => {
        if (1 < nodes.size) {
            return null
        }

        const onClick = async () => {
            const [dt] = nodes
            const {dmCode, dtCode, pkid: dtId, prjId, sVer} = dt.data

            if (dmCode) {
                openWindow('/ErDetail', {dmCode, dtCode, dtId, prjId, sVer})
            }
            else {
                openModal(
                    <Alert type="error">
                        未设置库表域
                    </Alert>
                )
            }
        }

        return {
            label: '查看ER图',
            onClick,
        }
    }
}
